<script>
import { Cell, Popup, Picker } from 'vant'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import Common from '@/tbs/model/to/Common'

const common = new Common

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'shortcut-date-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-picker': Picker
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        value: Date,
        baseDate: Date,
        disabled: Boolean,
        clearable: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            columns: [],
            selectedValue: null,
            selectedDate: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the area value to display on the cell item.
         */
         dateLabel() {
             let selectedLabel = ''
             if (this.selectedValue == '0') {
                 selectedLabel = common.localeProp('long-term')
             }
             else if (this.selectedDate) {
                 selectedLabel = DateTimeFunc.formatDate(this.selectedDate)
             }
             else if (this.value) {
                 selectedLabel = DateTimeFunc.formatDate(this.value)
                 if (selectedLabel == '2199-12-31') {
                     selectedLabel = common.localeProp('long-term')
                 }
             }
             return selectedLabel
         },
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onItemClick() {
            console.log('onItemClick')
            if (!this.disabled) {
                this.calcColumns(this.selectedValue)
                this.showPopup = true
            }
        },
        onCancelBtnClick() {
            console.log('onCancelBtnClick')
            /*this.selectedValue = null
            this.selectedDate = null
            this.$emit('change-data', {
                value: null,
                date: null
            })*/
            this.showPopup = false
        },
        onClearBtnClick() {
            console.log('onClearBtnClick')
            this.selectedValue = null
            this.selectedDate = null
            this.$emit('change-data', {
                value: null,
                date: null
            })
        },
        onConfirmBtnClick(values) {
            console.log('onConfirmBtnClick', arguments)
            this.selectedValue = values[0].value
            if (this.selectedValue == '0') {
                this.selectedDate = new Date('2199-12-31')
            }
            else {
                this.selectedDate = new Date()
                this.selectedDate.setFullYear(values[1])
                this.selectedDate.setMonth(values[2] - 1)
                this.selectedDate.setDate(values[3])
            }
            this.$emit('change-data', {
                value: this.selectedValue,
                date: new Date(this.selectedDate.getTime())
            })
            this.showPopup = false
        },
        onDataChange(target, values, columnIndex) {
            console.log('onDataChange', arguments)
            if (columnIndex == 0) {
                const selectedValue = values[0].value
                if (selectedValue != this.selectedValue) {
                    this.calcColumns(selectedValue)
                }
            }
        },
        getValueFromDate(date) {
            if (!date) {
                return
            }
            if (DateTimeFunc.formatDate(date) == '2199-12-31') {
                return '0'
            }
            else {
                const baseDate = this.baseDate || new Date
                let endDate
                endDate = new Date(baseDate.getTime())
                endDate.setDate(endDate.getDate() - 1)
                endDate.setFullYear(endDate.getFullYear() + 1)
                if (DateTimeFunc.formatDate(endDate) == DateTimeFunc.formatDate(date)) {
                    return '1'
                }
                endDate.setFullYear(endDate.getFullYear() + 9)
                if (DateTimeFunc.formatDate(endDate) == DateTimeFunc.formatDate(date)) {
                    return '10'
                }
                endDate.setFullYear(endDate.getFullYear() + 10)
                if (DateTimeFunc.formatDate(endDate) == DateTimeFunc.formatDate(date)) {
                    return '20'
                }
                endDate.setFullYear(endDate.getFullYear() + 10)
                if (DateTimeFunc.formatDate(endDate) == DateTimeFunc.formatDate(date)) {
                    return '30'
                }
                return '-1'
            }
        },
        calcColumns(selectedValue) {
            console.log('calcColumns', selectedValue, this.baseDate, this.value)
            const baseDate = this.baseDate || new Date
            const value = selectedValue || this.getValueFromDate(this.value) || '1'
            
            const shortcutValues = [
                { text: '1' + common.localeProp('year'), value: '1' },
                { text: '10' + common.localeProp('year'), value: '10' },
                { text: '20' + common.localeProp('year'), value: '20' },
                { text: '30' + common.localeProp('year'), value: '30' },
                { text: common.localeProp('long-term'), value: '0' },
                { text: common.localeProp('manual-selection'), value: '-1' },
            ]
            let shortcutIndex = 0
            const yearValues = []
            let yearIndex = 0
            const monthValues = []
            let monthIndex = 0
            const dateValues = []
            let dateIndex = 0
            let endDate
            
            if (value == '1') {
                shortcutIndex = 0
                endDate = new Date(baseDate.getTime())
                endDate.setDate(endDate.getDate() - 1)
                endDate.setFullYear(endDate.getFullYear() + 1)
                yearValues.push(endDate.getFullYear())
                monthValues.push(endDate.getMonth() + 1)
                dateValues.push(endDate.getDate())
            }
            else if (value == '10') {
                shortcutIndex = 1
                endDate = new Date(baseDate.getTime())
                endDate.setDate(endDate.getDate() - 1)
                endDate.setFullYear(endDate.getFullYear() + 10)
                yearValues.push(endDate.getFullYear())
                monthValues.push(endDate.getMonth() + 1)
                dateValues.push(endDate.getDate())
            }
            else if (value == '20') {
                shortcutIndex = 2
                endDate = new Date(baseDate.getTime())
                endDate.setDate(endDate.getDate() - 1)
                endDate.setFullYear(endDate.getFullYear() + 20)
                yearValues.push(endDate.getFullYear())
                monthValues.push(endDate.getMonth() + 1)
                dateValues.push(endDate.getDate())
            }
            else if (value == '30') {
                shortcutIndex = 3
                endDate = new Date(baseDate.getTime())
                endDate.setDate(endDate.getDate() - 1)
                endDate.setFullYear(endDate.getFullYear() + 30)
                yearValues.push(endDate.getFullYear())
                monthValues.push(endDate.getMonth() + 1)
                dateValues.push(endDate.getDate())
            }
            else if (value == '0') {
                shortcutIndex = 4
            }
            else {
                shortcutIndex = 5
                const currentYear = baseDate.getFullYear()
                const minYear = currentYear
                const maxYear = currentYear + 50
                for (let i = minYear; i <= maxYear; i++) {
                    yearValues.push(i.toString())
                }
                yearIndex = 1
                for (let i = 1; i <= 12; i++) {
                    monthValues.push(i.toString())
                }
                monthIndex = Math.floor(monthValues.length / 2)
                for (let i = 1; i <= 31; i++) {
                    dateValues.push(i.toString())
                }
                dateIndex = Math.floor(dateValues.length / 2)
            }

            // console.log('columns', value, shortcutValues, yearValues, monthValues, dateValues)
            this.selectedValue = value
            console.log('selectedValue', value)
            
            this.columns = [
                { values: shortcutValues, defaultIndex: shortcutIndex },
                { values: yearValues, defaultIndex: yearIndex },
                { values: monthValues, defaultIndex: monthIndex },
                { values: dateValues, defaultIndex: dateIndex },
            ]
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="shortcut-date-selector van-cell no-padding">
        <van-cell 
            class="van-cell-field"
            :class="{ disabled: disabled }"
            :title="label"
            center
            :value="dateLabel"
            @click="onItemClick"
        >
            <template #right-icon>
                <div v-if="!disabled" class="l-inner-margin minor-color">
                    <div v-if="clearable">
                        <van-icon 
                            v-if="selectedValue" 
                            name="clear"
                            size="16"
                            @click.stop="onClearBtnClick"
                        />
                        <van-icon v-else name="arrow"/>
                    </div>
                    <div v-else>
                        <van-icon name="arrow"/>
                    </div>
                </div>
            </template>
        </van-cell>
        <van-popup 
            v-model="showPopup"
            position="bottom"
        >
            <van-picker
                show-toolbar
                :title="label"
                :columns="columns"
                @cancel="onCancelBtnClick"
                @confirm="onConfirmBtnClick"
                @change="onDataChange"
            />
        </van-popup>
    </div>
</template>